import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { QSlider, QRange } from 'quasar'

// FIXME: refine model value condition

type RangeModelValue = { min?: number | null; max?: number | null } | null
type SliderModelValue = number | null

interface IEmits {
  (event: 'update:modelValue', data: RangeModelValue | SliderModelValue): void
}

interface IProps {
  modelValue: RangeModelValue | SliderModelValue
  isDouble?: boolean
  disable?: boolean
  hasIndicator?: boolean
  min?: number
  max?: number
  thumbColor?: string
  selectionColor?: string
  labelColor?: string
  trackColor?: string
  labelTextColor?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KRange' },
  __name: 'KRange',
  props: {
    modelValue: {},
    isDouble: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    hasIndicator: { type: Boolean, default: true },
    min: { default: 0 },
    max: { default: 100 },
    thumbColor: { default: 'space-b-70' },
    selectionColor: { default: 'space-b-70' },
    labelColor: { default: 'space-b-70' },
    trackColor: { default: 'space-b-50' },
    labelTextColor: { default: 'static-light' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.isDouble ? _unref(QRange) : _unref(QSlider)), {
    class: "k-range",
    min: __props.min,
    max: __props.max,
    label: __props.hasIndicator,
    "label-always": __props.hasIndicator,
    "thumb-color": !__props.disable ? __props.thumbColor : 'cool-gray-40',
    "selection-color": !__props.disable ? __props.selectionColor : 'cool-gray-40',
    "track-color": !__props.disable ? __props.trackColor : 'off-white-20',
    "label-color": !__props.disable ? __props.labelColor : 'cool-gray-40',
    "label-text-color": !__props.disable ? __props.labelTextColor : 'cool-gray-60',
    disable: __props.disable,
    "model-value": __props.isDouble ? (__props.modelValue as SliderModelValue) : (__props.modelValue as SliderModelValue),
    dense: "",
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, null, 40 /* PROPS, NEED_HYDRATION */, ["min", "max", "label", "label-always", "thumb-color", "selection-color", "track-color", "label-color", "label-text-color", "disable", "model-value"]))
}
}

})